import { Component, Input, OnInit } from '@angular/core';
import { Asset } from "../../../../model/asset";
import { Trigger } from "../../../../model/trigger";
import { SortOrder } from "../../../../model/sort-order";
import { TriggerFilters } from "../../../../model/filters/trigger-filters";
import { TriggersService } from "../../../../services/triggers.service";

@Component({
  selector: 'app-asset-triggers',
  templateUrl: './asset-triggers.component.html',
  styleUrls: ['./asset-triggers.component.scss']
})
export class AssetTriggersComponent implements OnInit {

  @Input()
  public asset: Asset;

  public assetTriggers: Trigger[];
  public totalTriggers: number;
  public loadingTriggers: boolean;

  public rows = 10;
  public first = 0;

  public currentFilters: TriggerFilters;

  constructor(private triggersService: TriggersService) {}

  ngOnInit(): void {
    this.resetFilters();
    this.loadTriggers(this.first/this.rows, this.rows)
  }

  private loadTriggers(offset: number, limit: number) {
    this.loadingTriggers = true;
    this.triggersService.getTriggers(offset, limit, this.currentFilters)
      .subscribe(response => {
        this.assetTriggers = response.triggers;
        this.totalTriggers = response.totalElements;
        this.loadingTriggers = false;
      })
  }

  onPageChange(event) {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadTriggers(event.first/event.rows, event.rows);
  }

  resetFilters() {
    this.currentFilters = new TriggerFilters();
    this.currentFilters.entityType = 'ASSET';
    this.currentFilters.entityUuid = this.asset.uuid;
  }

  applyFilters() {
    this.first = 0;
    this.loadTriggers(this.first/this.rows, this.rows);
  }

}
